import React from 'react'; 
import { useNavigate } from 'react-router-dom';
import stopImg1 from '../../../img/Stop1.jpeg'; // First image
import stopImg2 from '../../../img/Stop2.jpeg'; // Second image
import stopImg3 from '../../../img/Stop3.jpeg'; // Third image

const ProductsStops = () => {
  const navigate = useNavigate();

  const stopsProducts = [
    {
      stopNumber: "S001",
      description: "Durable stop with a sleek design, ideal for both modern and traditional spaces.",
      image: stopImg1 // First image
    },
    {
      stopNumber: "S002",
      description: "Heavy-duty stop designed for maximum durability and long-lasting performance.",
      image: stopImg2 // Second image
    },
    {
      stopNumber: "S003",
      description: "Compact and stylish stop, perfect for small spaces or minimalist designs.",
      image: stopImg3 // Third image
    },
  ];

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-3xl font-bold text-center mb-8 font-montserrat">Stops Collection</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {stopsProducts.map((product) => (
          <div
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full"
            key={product.stopNumber}
          >
            <img
              src={product.image}
              alt={`Stop ${product.stopNumber}`}
              className="w-full h-48 object-cover"
            />
            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold text-gray-800 mb-2">
                Stop {product.stopNumber}
              </h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                {product.description}
              </p>
            </div>
          </div>
        ))}

        {/* Informative Card */}
        <div
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
          <div>
            <h5 className="text-xl font-bold text-emerald-50 mb-4">Need More Information?</h5>
            <p className="text-emerald-100 mb-4">
              Interested in our stops? Want to discuss custom designs or get a quote? 
              Our team is ready to help you find the perfect stop for your project.
            </p>
            <p className="text-emerald-100">
              To view the complete list of products, please register to obtain your access token (key).
            </p>
          </div>
          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contact us →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsStops;
